import { Card, CardContent } from 'shared/ui/card'
import type { OpenPermitStats as OpenPermitStatsType } from './types'

interface OpenPermitStatsProps {
  statistics: OpenPermitStatsType
}

export function OpenPermitStats({ statistics }: OpenPermitStatsProps) {
  return (
    <div className="grid gap-4 md:grid-cols-4">
      <Card className="border-slate-200 shadow-sm"><CardContent className="p-4"><p className="text-sm text-slate-500">รอเปิด Permit เข้าทำงาน</p><p className="mt-2 text-3xl font-semibold text-slate-900">{statistics.total}</p></CardContent></Card>
      <Card className="border-slate-200 shadow-sm"><CardContent className="p-4"><p className="text-sm text-slate-500">Cold Work</p><p className="mt-2 text-3xl font-semibold text-blue-600">{statistics.coldWork}</p></CardContent></Card>
      <Card className="border-slate-200 shadow-sm"><CardContent className="p-4"><p className="text-sm text-slate-500">Hot Work</p><p className="mt-2 text-3xl font-semibold text-red-600">{statistics.hotWork}</p></CardContent></Card>
      <Card className="border-slate-200 shadow-sm"><CardContent className="p-4"><p className="text-sm text-slate-500">Confine Work</p><p className="mt-2 text-3xl font-semibold text-violet-600">{statistics.confineWork}</p></CardContent></Card>
    </div>
  )
}
